import store from '@/store'

const currentUser = store.getters['user/currentUser']

function initSupport() {
    const widget = new SupportWidget({
        api_key: import.meta.env.VITE_APP_KEY,
        api_base: import.meta.env.VITE_API_BASE,
        api_prefix: '/api/v1/',
        socket_base: import.meta.env.VITE_SOCKET_BASE,
        user: {
            email: currentUser?.email,
            name: currentUser?.fullname,
        },
        language: localStorage.getItem('locale'),
    })

    widget.init('#support-trigger')

    const badge = document.getElementById('support-badge')

    document
        .getElementById('support-trigger')
        .addEventListener('supportwidget:unread', () => {
            const count = widget.getTotalUnread()
            badge.textContent = count
            badge.style.display = count > 0 ? 'flex' : 'none'
        })
}

initSupport()
